import {NavigationEvent} from "./NavigationEvent";
import {EventEmitter,Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
/**
 * Created by oksuztepe on 09/01/17.
 */

@Injectable()
export class NavigationService {
  public value:string;
  //public eventOccured$: EventEmitter<NavigationEvent>;
  private eventOccuredSource:BehaviorSubject<NavigationEvent> = new BehaviorSubject<NavigationEvent>(new NavigationEvent("", ""));

  eventOccured$ = this.eventOccuredSource.asObservable();
  // service command
  action(event:NavigationEvent) {
    this.eventOccuredSource.next(event);
    this.eventOccuredSource.next(new NavigationEvent("", ""));
  }

  constructor() {
    //  this.eventOccured$ = new EventEmitter<NavigationEvent>();
    this.value = "1";
  }


}
